import classes from './PercentCell.module.css'
import classesCell from './BodyCell.module.css'

export default function PercentCell({text}) {
    return <div className={`${classes.CurencyCell_cell} ${classesCell.body_cell}`}>
        {text && <>{text}%</>}
    </div>
}